import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { GlobalConfig } from '../entities/global-config';
import { HttpService } from '../service/http.service';
@Injectable()
export class HttpserviceService {

  constructor(private config: GlobalConfig, private serviceHttp: HttpService, private http: Http) { }

  logIn(user: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/token', user);
  }

  getAgents(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/agents', page);
  }
 
  getAgentsGmk() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getAgentsGmk');
  }

  getPackages() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/packages');
  }

  GetAgents() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getAgents');
  }

  getDistricts() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getDistricts');
  }

  getCategories() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getCategories');
  }

  getFacilities() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getFacilities');
  }

  getCountry() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getCountries');
  }

  getState() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getStates');
  }

  getCity() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getCities');
  }

  getArea() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getAreas');
  }

  getSubArea() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getSubAreas');
  }

  getSubSubArea() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getSubSubAreas');
  }

  getPermissions() {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getPermissions');
  }


  saveAgent(agent: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/agent/saveAgent', agent);
  }

  updateAgentPassword(agent: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/agent/updateAgentPassword', agent);
  }

  getAgentDetail(agentId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/agent/' + agentId);
  }

  updateAgent(agent: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/agent/updateAgent', agent);
  }

  enableDisableAgent(agentIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/agent/enableDisableAgent', agentIds);
  }

  delete(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/agent/delete/' + id);
  }

  //areas
  getAreas(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/areas', page);
  }

  saveArea(area: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/areas/saveArea', area);
  }

  getAreaDetail(areaId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/areas/' + areaId);
  }

  updateArea(area: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/areas/updateArea', area);
  }

  enableDisableArea(areaIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/areas/enableDisableAreas', areaIds);
  }

  deleteArea(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/areas/delete/' + id);
  }

  //cities
  getCitiesAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cities', page);
  }

  saveCity(city: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cities/saveCity', city);
  }

  getCityDetail(cityId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cities/' + cityId);
  }

  enableDisableCity(cityIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cities/enableDisableCities', cityIds);
  }

  deleteCity(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cities/delete/' + id);
  }

  //subAreas
  getSubAreas(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subAreas', page);
  }

  getSubAreasByArea(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/getSubAreasbyArea/' + id);
  }

  deleteSubArea(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subAreas/delete/' + id);
  }

  saveSubArea(subArea: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subAreas/saveSubArea', subArea);
  }

  getSubAreaDetail(subAreaId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subAreas/' + subAreaId);
  }

  enableDisableSubArea(subAreasIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subAreas/enableDisableAreas', subAreasIds);
  }

  //sub subAreas
  getSubSubAreas(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subSubAreas', page);
  }

  deleteSubSubArea(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subSubAreas/delete/' + id);
  }

  saveSubSubArea(subArea: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subSubAreas/saveSubSubArea', subArea);
  }

  getSubSubAreaDetail(subAreaId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subSubAreas/' + subAreaId);
  }

  enableDisableSubSubArea(subAreasIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subSubAreas/enableDisableAreas', subAreasIds);
  }

  //districts
  getdistrictsAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/districts', page);
  }

  saveDistrict(districts: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/districts/saveDistric', districts);
  }

  getDistrictDetail(districtId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/districts/' + districtId);
  }

  enableDisableDistrict(districtIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/districts/enableDisableDistricts', districtIds);
  }

  deleteDistrict(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/districts/delete/' + id);
  }

  //states
  getstatesAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/states', page);
  }

  saveState(states: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/states/saveStates', states);
  }

  getStateDetail(stateId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/states/' + stateId);
  }

  enableDisableState(stateIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/states/enableDisableStates', stateIds);
  }

  deleteState(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/states/delete/' + id);
  }
  //countries
  getcountriesAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/countries', page);
  }

  saveCountry(country: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/countries/saveCountry', country);
  }

  getCountryDetail(countryId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/countries/' + countryId);
  }

  enableDisableCountry(countryIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/countries/enableDisableDistricts', countryIds);
  }

  deleteCountry(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/countries/delete/' + id);
  }

  //category
  getcategoriesAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/category', page);
  }

  saveCategory(category: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/category/saveCategory', category);
  }

  getCategoryDetail(categoryId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/category/' + categoryId);
  }

  enableDisableCategory(categoryIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/category/enableDisableCategory', categoryIds);
  }

  deleteCategory(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/category/delete/' + id);
  }

  //facilities
  getFacilityAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/facility', page);
  }

  saveFacility(facility: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/facility/saveFacility', facility);
  }

  getFacilityDetail(facilityId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/facility/' + facilityId);
  }

  enableDisableFacility(facilityIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/facility/enableDisableFacility', facilityIds);
  }

  deleteFacility(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/facility/delete/' + id);
  }

  //furnishing
  GetFurnishingAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/furnishing', page);
  }

  saveFurnish(furnishes: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/furnishing/saveFurnishing', furnishes);
  }

  getFurnishDetail(furnishId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/furnishing/' + furnishId);
  }

  enableDisableFurnishing(furnishingIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/furnishing/enableDisableFurnishing', furnishingIds);
  }

  deleteFurnish(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/furnishing/delete/' + id);
  }


  //furnishing
  GetRentalsAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/rentales', page);
  }

  saveRental(rentals: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/rentales/saveRentales', rentals);
  }

  getRentalDetail(rentalId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/rentales/' + rentalId);
  }

  enableDisableRental(rentalsIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/rentales/enableDisableRentals', rentalsIds);
  }

  deleteRental(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/rentales/delete/' + id);
  }

  //property
  getPropertyAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/property', page);
  }

  getPropertyDetail(propertyId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/property/' + propertyId);
  }

  getPropertyPhotoDetail(propertyId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/property/getPropertyPhoto/' + propertyId);
  }

  saveProperty(properties: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/property/saveProperty', properties);
  }

  enableDisableProperty(propertyIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/property/enableDisableProperty', propertyIds);
  }

  deleteProperty(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/property/delete/' + id);
  }
  managefeatured(featuredValue, propertyId) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/property/manageFeatured/' + featuredValue + '/' + propertyId);
  }

  deletePropertyImage(image: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/property/deletePropertyImage', image);
  }

  // Leads
  getEmailLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/emailLead', page);
  }

  getPhoneLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/phoneLead', page);
  }

  getCallTracker(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/getVirtualCallDetail', page);
  }

  exportEmailLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/emailLead/export', page);
  }

  exportPhoneLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/phoneLead/export', page);
  }

  getWhatsappLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/whatsappLead', page);
  }

  exportWhatsappLead(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/whatsappLead/export', page);
  }


  // Packages
  getPackagesAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/packages', page);
  }

  savePackage(packages: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/packages/savePackages', packages);
  }

  getPackageDetail(packageId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/packages/' + packageId);
  }

  enableDisablePackage(packageIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/packages/enableDisablePackages', packageIds);
  }

  deletePackage(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/packages/delete/' + id);
  }

  //Subscriber
  getSubscriberAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subscriber', page);
  }

  updateSubscriber(subscriber: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/subscriber/updateSubscriber', subscriber);
  }

  getSubscriberDetail(subscriberId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subscriber/' + subscriberId);
  }

  deleteSubscriber(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/subscriber/delete/' + id);
  }

  //role
  getRoleAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/roles', page);
  }

  saveRole(roles: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/roles/saveRole', roles);
  }

  addRolePermissions(rolePermissions: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/roles/saveRolePermissions', rolePermissions);
  }

  getAgentListByName(agentName: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/GetAgentByName/' + agentName);
  }

  addRoleUsers(rolePermissionUser: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/roles/saveRoleUsers', rolePermissionUser);
  }
  getRoleDetail(roleId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/roles/' + roleId);
  }

  GetPermissionsByRoleId(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/roles/GetRolePermissions/' + id);
  }

  deleteRole(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/roles/delete/' + id);
  }

  getUsersByRoleId(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/roles/getUsersByRoleId/' + id);
  }


  //Dashboard
  getDashboard(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/dashboard', page);
  }


  //permission
  getPermissionAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/permission', page);
  }

  savePermission(permission: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/permission/savePermission', permission);
  }

  getRouteListByName(routeName: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/GetRouteNameByName/' + routeName);
  }

  getRoleListByName(roleName: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/GetRolesByName/' + roleName);
  }

  addRoutePermissions(routepermission: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/permission/saveRoutePermission', routepermission);
  }

  savePermissionRole(rolePermission: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/permission/setPermissionRole', rolePermission);
  }

  getPermissionDetail(permissionId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/permission/' + permissionId);
  }

  getRoutesByPermissionId(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/permission/getRoutesByPermissionId/' + id);
  }

  getRolesByPermissionId(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/permission/getRolesByPermissionId/' + id);
  }
  deletePermissions(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/permission/delete/' + id);
  }

  enableDisablePermission(permissionsIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/permission/enableDisablePermission', permissionsIds);
  }


  //route
  getRouteAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/routes', page);
  }

  saveRoute(route: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/routes/saveRoute', route);
  }

  getRouteDetail(routeId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/routes/' + routeId);
  }

  enableDisableRoute(routeIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/routes/enableDisableRoutes', routeIds);
  }

  deleteRoute(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/routes/delete/' + id);
  }

  addPermission(id, permissionId) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/routes/manageFeatured/' + id + '/' + permissionId);
  }

  enableDisableRole(rolesIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/roles/enableDisableRoles', rolesIds);
  }

  getUserDetail(userId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/user/' + userId);
  }

  getRolesDetail(userId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/userRoleDetail/' + userId);
  }

  getUserPermissionDetail(userId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/userPermissionDetail/' + userId);
  }

  updateUserDetails(user: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/user/updateUser', user);
  }

  // users
  getUserAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/users', page);
  }

  enableDisableUser(usersIds: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/users/enableDisableUsers', usersIds);
  }

  deleteUser(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/users/delete/' + id);
  }

  saveUser(users: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/users/saveUser', users);
  }

  addUserRoles(rolePermissionUser: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/users/saveUserRoles', rolePermissionUser);
  }

  // blacklist
  getBlacklistAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/domain/getBlacklist', page);
  }

  deleteBlacklist(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/domain/deleteBlacklist/' + id);
  }

  saveBlacklist(blacklist: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/domain/saveBlacklist', blacklist);
  }

  // blacklist
  getVisitorsAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/domain/getVisitorLog', page);
  }

  // getDetailsByUserId(id: any) {
  //   return this.serviceHttp.get(this.config.apiRootUrl + 'api/users/getDetailsByUserId/' + id);
  // }

  // getUserRolesDetail(id: any) {
  //   return this.serviceHttp.get(this.config.apiRootUrl + 'api/user/roles' + id);
  // }

  // Cronjob
  getCronjobAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronjob', page);
  }

  saveCronjob(cronjob: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronjob/saveCronjob', cronjob);
  }

  getCronjobDetail(packageId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cronjob/' + packageId);
  }

  deleteCron(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cronjob/delete/' + id);
  }

  getXmlUrl(agentId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cronjob/' + agentId);
  }

  runXml(cronjob: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronjob/run', cronjob);
  }

  // Cronjob
  getCronjobGmkAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronJobGMK', page);
  }

  saveCronjobGmk(cronjob: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronjob/saveCronjobGmk', cronjob);
  }

  getCronjobDetailGmk(gmkId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/cronjob/Gmk/' + gmkId);
  }

  //logas

  getLogAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/cronjob/logs', page);
  }

  //inquires

  getInquiresAsync(page: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/rentalinquiry', page);
  }

  updateInquires(subscriber: any) {
    return this.serviceHttp.post(this.config.apiRootUrl + 'api/rentalinquiry/updateRentalinquiry', subscriber);
  }

  getInquiresDetail(subscriberId: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/rentalinquiry/' + subscriberId);
  }

  deleteInquires(id: any) {
    return this.serviceHttp.get(this.config.apiRootUrl + 'api/rentalinquiry/delete/' + id);
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/service/http.service.service.ts